import React, { Fragment } from "react";
//import Moment from 'react-moment';

export const TransactionsComponent = ({ transactions, title, isDashboard }) => {
  return (
    <Fragment>
      <div className="dashboard-card">
        <h4 className="transaction-title-header">{title}</h4>
        <table className="table table-dark oi-table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Type</th>
              <th scope="col">Message</th>
              <th scope="col">Amount</th>
              {!isDashboard && (<th scope="col">User Email</th>)}

              <th scope="col">Username</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((trx, index) => (
              <tr key={trx.id || index}>
                <th scope="row">{trx.id.substring(0, 6)}</th>
                <td>{trx.type}</td>
                <td>{trx.message}</td>
                <td>{trx.amount}</td>
                {!isDashboard && <td>{trx.email} </td>}
                <td>{trx.username}</td>
                <td>{trx.status > 0 ? "Success" : "Pending"}</td>
                <td>
                  {/*<Moment format="YYYY/MM/DD">{trx.created_at}</Moment>*/}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};
